export const SECURE_SESSION_SOCKET_EVENTS = {
  ABANDONED_BY_CLIENT: 'session_abandoned_by_client',
  EVENT_HANDLER_ERROR: 'event_handler_error',
  FAILED: 'session_failed',
  KICKOFF: 'session_kickoff',
  LAUNCHED: 'session_launched',
  SUCCEEDED: 'session_succeeded',
  TIMED_OUT_NO_ACTIVITY: 'session_timed_out_no_activity',
  TIMED_OUT_UNABLE_TO_LOGIN: 'session_timed_out_unable_to_login',
  TRY_LATER: 'session_try_later',
} as const;

export type SecureSessionSocketEvent = (typeof SECURE_SESSION_SOCKET_EVENTS)[keyof typeof SECURE_SESSION_SOCKET_EVENTS];
